import { render, staticRenderFns } from "./CustomerLogHistory.vue?vue&type=template&id=9c53ed38&"
import script from "./CustomerLogHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerLogHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports